/**
 * Created by ShaunBetts on 14-May-16.
 */

import PortalError from 'module/error/PortalError';

const ConnectionError = function (message, code) {
  this.data = new PortalError(message, code).data;
  this.data.type = 'ConnectionError';
  this.data.typeLabel = 'Cannot Connect';
};

ConnectionError.prototype = Object.create(PortalError.prototype);

export default ConnectionError;